import { Dialog, Notify, Quasar } from 'quasar'
import { type UserModule } from '~/types'
import 'quasar/src/css/index.sass'
//import '~/common/styles/fs-icons.css'

import '@quasar/extras/material-icons/material-icons.css'
import '@quasar/extras/animate/fadeInDown.css'

export const install: UserModule = ({ app }) => {
  Quasar.iconSet.iconMapFn = (iconName: string) => {
    if (iconName.startsWith('fs-')) {
      return {
        cls: iconName,
      }
    }
  }

  app.use(Quasar, {
    config: {},
    plugins: {
      Dialog,
      Notify,
    },
  })
}
